// removed by extract-text-webpack-plugin
module.exports = {"container":"NoSurveys__container___3sPp1","image":"NoSurveys__image___1bf--","text":"NoSurveys__text___T8rDn"};